function Button (props) {
    return ( 
        <button 
            tabIndex={props.tab}
            onClick={props.event}
            type="submit"
            className={props.design} >
            <span>
            { props.title }
            </span>
        </button>
    )
}

export default Button;